<template>
  <router-view />
</template>

<script>
export default {
  name: 'ConnectionDetailIndex'
};
</script>

<style></style>
